export default __webpack_public_path__ + "static/media/dumbbell.9d22814b.svg";